class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection-grid-container').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (document.getElementById('SortBy')) {
          document.getElementById('SortBy').dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (document.getElementById('SortBy')) {
      document.getElementById('SortBy').dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (
      window.themeCollectionAvailability &&
      typeof window.themeCollectionAvailability.sortGrid === 'function'
    ) {
      window.themeCollectionAvailability.sortGrid();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersForm .js-filter');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        /*
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
        */
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement.querySelector('.facets__summary');

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);

    // Also render custom-tag chips client-side (for tag URL filters)
    try {
      renderCustomTagChips();
    } catch (e) {}
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    // console.log(new URLSearchParams(formData).toString());
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const params = new URLSearchParams();

    const currentUrl = new URL(window.location.href);
    const sortParam = currentUrl.searchParams.get('sort_by');
    if (sortParam) {
      params.set('sort_by', sortParam);
    }

    const sortBySelect = document.getElementById('SortBy');
    if (sortBySelect && sortBySelect.value) {
      params.set('sort_by', sortBySelect.value);
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    sortFilterForms.forEach((form) => {
      const checkboxInputs = form.querySelectorAll('input[type="checkbox"]');
      checkboxInputs.forEach(input => {
        if (input.checked && !input.hasAttribute('data-custom-tag-filter')) {
          params.append(input.name, input.value);
        }
      });

      const otherInputs = form.querySelectorAll('input:not([type="checkbox"])');
      otherInputs.forEach(input => {
        if (input.value && input.name !== 'sort_by' && !input.hasAttribute('data-custom-tag-filter')) {
          params.set(input.name, input.value);
        }
      });

      const selectElements = form.querySelectorAll('select');
      selectElements.forEach(select => {
        if (select.value && select.name === 'sort_by') {
          params.set('sort_by', select.value);
        }
      });
    });

    this.onSubmitForm(params.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Escape'];
    if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute('data-max', maxInput.value);
    } else {
      minInput.setAttribute('data-max', maxInput.getAttribute('max'));
    }

    if (minInput.value) {
      maxInput.setAttribute('data-min', minInput.value);
    } else {
      maxInput.setAttribute('data-min', minInput.getAttribute('min'));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min')) || 0; // Default to input's min attribute
    const max = Number(input.getAttribute('max')); // Default to input's max attribute

    if (!isNaN(min) && value < min) input.value = min;
    if (!isNaN(max) && value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Custom Tag Filter (legacy tag URLs) integrated with Apply Filters
function getCustomTagGroups() {
  const optionInputs = Array.from(document.querySelectorAll('.facets__custom-tag-options input[data-custom-tag-option]'));
  const allGroupTags = new Set(optionInputs.map(i => i.value).filter(Boolean));
  const selectedTagInputs = Array.from(document.querySelectorAll('.facets__custom-tag-options input[data-custom-tag-filter]:checked'))
    .filter(i => i.value !== 'all');
  const selectedTags = selectedTagInputs.map(i => i.value).filter(Boolean);
  return { allGroupTags, selectedTags };
}

function buildParamsFromForms() {
  const params = new URLSearchParams();
  const currentUrl = new URL(window.location.href);
  const sortParam = currentUrl.searchParams.get('sort_by');
  if (sortParam) params.set('sort_by', sortParam);
  const sortBySelect = document.getElementById('SortBy');
  if (sortBySelect && sortBySelect.value) params.set('sort_by', sortBySelect.value);
  const sortFilterForms = document.querySelectorAll('facet-filters-form form');
  sortFilterForms.forEach((form) => {
    const checkboxInputs = form.querySelectorAll('input[type="checkbox"]');
    checkboxInputs.forEach(input => { if (input.checked) params.append(input.name, input.value); });
    const otherInputs = form.querySelectorAll('input:not([type="checkbox"])');
    otherInputs.forEach(input => { if (input.value && input.name !== 'sort_by') params.set(input.name, input.value); });
    const selectElements = form.querySelectorAll('select');
    selectElements.forEach(select => { if (select.value && select.name === 'sort_by') params.set('sort_by', select.value); });
  });
  return params;
}

document.addEventListener('click', (e) => {
  const applyBtn = e.target.closest('.drawer__row--buttons .js-btn-close-drawer');
  if (!applyBtn) return;

  const { allGroupTags, selectedTags } = getCustomTagGroups();
  if (allGroupTags.size === 0) return; // no custom groups, fall back to default

  e.preventDefault();

  const parts = window.location.pathname.split('/').filter(Boolean);
  const collIndex = parts.indexOf('collections');
  let existingTags = [];
  if (collIndex > -1 && parts.length > collIndex + 2) {
    existingTags = parts.slice(collIndex + 2);
  }
  const filtered = existingTags.filter(t => !allGroupTags.has(t));
  const combined = [...filtered, ...selectedTags];
  const base = parts.slice(0, collIndex + 2).join('/');
  const tagPath = combined.length ? '/' + combined.join('+') : '';
  const params = buildParamsFromForms();

  // Update URL without full page reload and trigger AJAX render like native facets
  const newPath = '/' + base + tagPath;
  const paramsString = params.toString();
  history.pushState({ searchParams: paramsString }, '', newPath + (paramsString ? '?' + paramsString : ''));
  FacetFiltersForm.renderPage(paramsString, null, false);

  // Close the drawer if present
  const closeBtn = document.querySelector('.drawer__button-close--facets');
  if (closeBtn) closeBtn.click();
});

// Preselect radios based on current URL tags
document.addEventListener('DOMContentLoaded', () => {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const collIndex = parts.indexOf('collections');
  let currentTags = [];
  if (collIndex > -1 && parts.length > collIndex + 2) currentTags = parts.slice(collIndex + 2);
  document.querySelectorAll('.facets__custom-tag-options').forEach(group => {
    const boxes = group.querySelectorAll('input[data-custom-tag-filter]');
    boxes.forEach(b => {
      b.checked = b.hasAttribute('data-custom-tag-option') && currentTags.includes(b.value);
    });
  });
});

// Build and render custom tag chips alongside native active facets
function getCurrentTags() {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const idx = parts.indexOf('collections');
  if (idx > -1 && parts.length > idx + 2) return parts.slice(idx + 2);
  return [];
}

function buildPathWithoutTag(tag) {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const idx = parts.indexOf('collections');
  if (idx === -1) return window.location.pathname;
  const base = parts.slice(0, idx + 2).join('/');
  const current = getCurrentTags();
  const filtered = current.filter(t => t !== tag);
  const tagPath = filtered.length ? '/' + filtered.join('+') : '';
  return '/' + base + tagPath;
}

function renderCustomTagChips() {
  const container = document.querySelector('.active-facets');
  if (!container) return;
  const current = getCurrentTags();
  if (!current.length) return;

  const frag = document.createDocumentFragment();
  current.forEach(tag => {
    const btn = document.createElement('div');
    btn.className = 'active-facets__button';
    btn.innerHTML = `
      <div class="active-facets__button-text"><span>${decodeURIComponent(tag)}</span></div>
      <facet-remove>
        <a href="${buildPathWithoutTag(tag)}${window.location.search}" class="active-facets__button-link">
          <div class="svg-wrapper">${document.querySelector('.active-facets .svg-wrapper')?.innerHTML || ''}</div>
        </a>
      </facet-remove>
    `;
    frag.appendChild(btn);
  });
  container.appendChild(frag);

  // Ensure clicks use AJAX rendering just like native chips
  container.querySelectorAll('facet-remove a').forEach(a => {
    a.addEventListener('click', (event) => {
      event.preventDefault();
      const url = event.currentTarget.href.indexOf('?') === -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      history.pushState({ searchParams: url }, '', event.currentTarget.href);
      FacetFiltersForm.renderPage(url, null, false);
    });
  });
}
